import { ORIGIN_TMDB, ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../../constants/metaMovieOrigins'

const SOURCE_LABELS = {
    [ORIGIN_TMDB]: 'TMDB',
    [ORIGIN_DATA_PROVIDER]: 'Kassensystem',
    [ORIGIN_PM]: 'Pmkino',
}

const SOURCE_MODIFIER = {
    [ORIGIN_TMDB]: 'tmdb',
    [ORIGIN_DATA_PROVIDER]: 'ks',
    [ORIGIN_PM]: 'pm',
}

const SourceField = ({ metaKey, metaValue, sources, onSetOrigin }) => (
    <div className="source-field source-field--pills">
        {sources.map(src => (
            <button
                key={src}
                className={
                    'source-pill source-pill--' + SOURCE_MODIFIER[src] +
                    (metaValue === src ? ' source-pill--active' : '')
                }
                onClick={() => onSetOrigin(metaKey, src)}
                type="button"
            >
                {SOURCE_LABELS[src]}
            </button>
        ))}
    </div>
)

export default SourceField
